<script>
    import { GPU } from "gpu.js";
    import { afterUpdate } from "svelte";
    import * as d3 from "d3";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js";
    import { Delaunay } from "d3-delaunay";


    export let xpos;
    export let ypos;
    export let width;
    export let height;
    export let values;
    export let dr_scale = null;
    export let value_scale;
    export let type = "idw";

    const gpu = new GPU();
    $: render = gpu.createKernel(function (xpos, ypos, values) {
        let d = 0;
        let n = 0;
        let flagDist = -1;
        const z = 4;
        for (let i = 0; i < this.constants.numPoints; ++i) {
            const weight = Math.pow(Math.pow(xpos[i] - this.thread.x * 2, z) + Math.pow(ypos[i] - this.thread.y * 2, z), 1 / z);
            n = n + (values[i] / weight);
            d = d + (1 / weight);
            //if (weight < 1) flagDist = i;
        }

        let value = flagDist >= 0 ? values[flagDist] : (n / d);
        return value
        //let v = Math.ceil(255 * value);
        //return v;
        //return value;
    })
        .setConstants({ numPoints: values.length })
        .setOutput([width / 2, height / 2]);

    /* const colorscaleCanvas = new OffscreenCanvas(256, 1);
    const context = colorscaleCanvas.getContext("2d");
    const gradient = context.createLinearGradient(0, 0, 256, 1);

    for (let i = 0; i < 100; ++i) {
        gradient.addColorStop(i / 100, d3.interpolateRdYlBu(100 - i / 100));
    }
    gradient.addColorStop(1.0, d3.interpolateRdYlBu(1.0));
    gradient.addColorStop(0.5, d3.interpolateRdYlBu(0.5));
    gradient.addColorStop(0.0, d3.interpolateRdYlBu(0.0));
    context.fillStyle = gradient;
    context.fillRect(0, 0, 256, 1);
    const colorscale = context.getImageData(0, 0, 255, 1).data; */
    //let scaleExtent = [-1.2, 1.2]
    let scaleExtent = [-2, 2]
    //let scaleExtent;
    //$: scaleExtent = value_scale.domain();
    let thresholds = [];
    const numberThresholds = 80
    $: contour_colorscale = value_scale//d3.scaleSequential(d3.interpolateRdYlBu).domain(scaleExtent);

    afterUpdate(() => {
        if (!(values.length > 0 && xpos.length > 0)) return
        if (values[0] == undefined) return
        thresholds = druid.linspace(...scaleExtent, numberThresholds)
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, width, height);

        if (type == "idw") {
            let R = render(xpos, ypos, values)
            const contours = d3.contours()
                .size([width / 2, height / 2])
                .thresholds(thresholds)(R.map(a => Array.from(a)).flat())
                
            context.clearRect(0, 0, width, height);
            context.setTransform(2,0,0,2,0,0);
            const path = d3.geoPath(null, context);

            for (const contour of contours) {
                const threshold = contour.value;
                context.beginPath();
                context.fillStyle = contour_colorscale(threshold)
                path(contour);
                context.fill();
            }
        } else {
            context.setTransform(1,0,0,1,0,0);
            const delaunay = Delaunay.from(d3.zip(xpos, ypos), d => d[0], d => d[1])
            const voronoi = delaunay.voronoi([-1, -1, width + 1, height + 1])
            const polygons = Array.from(voronoi.cellPolygons());
            for (let i = 0; i < polygons.length; ++i) {
                context.fillStyle = value_scale(values[i]);
                context.beginPath();
                voronoi.renderCell(i, context);
                context.fill();    
            }
        }

    })
    console.log("values", values, xpos, ypos)

    let canvas;
</script>


<canvas bind:this={canvas} width={width} height={height}>

</canvas>
<svg width={width} height={130}>
    <g>
    {#each thresholds as t, i}
        <rect
            x={20 + i * ((width - 40) / numberThresholds)}
            y={20}
            width={(width - 40) / numberThresholds}
            height={(width - 40) / 20}
            fill={contour_colorscale(t)}
        ></rect>
        {#if i % Math.floor((width - 40) / numberThresholds * 2) == 0}

            <g transform="translate({20 + i * ((width - 40) / numberThresholds)}, {(width - 40) / 20 + 20 + 8}) rotate(45)">
                <text
                    font-size="9px"
                    fill="#555"
                    text-anchor="start">
                    { d3.format(".2f")(t)}
                </text>
            </g> 
        {/if}
    {/each}
    </g>
    <g transform="translate(0, 50)">
        {#each dr_scale.domain() as dr, i}
            <rect 
                x={20 + i * ((width - 40) /  dr_scale.domain().length)}
                y={20}
                height={(width - 40) / 20}
                width={(width - 40) / 20}
                fill={dr_scale(dr)}
                
            />
            
            <g transform="translate({20 + i * ((width - 40) / dr_scale.domain().length)}, {(width - 40) / 20 + 20 + 8}) rotate(45)">
                <text
                    x=5
                    y=-2.5
                    font-size="9px"
                    fill="#555"
                    text-anchor="start">
                    {dr}
                </text>
            </g> 
        {/each}
    </g>
</svg>

<style>
    canvas {
        border-radius: 1rem;
    }

    svg {
        shape-rendering: crispEdges;
    }
</style>